/* Sessie-intrekking, op één plek.

   De app kan lang blijven staan met gecachete gegevens. Wordt de sessie
   ondertussen ingetrokken, dan is «de lokale kopie wissen» niet genoeg: het
   private scherm bleef gemount met oude inhoud, en de hint dat dit apparaat
   een sessie kende bleef staan — waardoor een volgende koude start opnieuw de
   private shell opende.

   Iedere 401 meldt zich hier -- uit `api.ts` én uit de outbox-flush; de app
   sluit dan af en wist alles wat lokaal van deze sessie was. Een 403 hoort
   hier NIET: dat is één geweigerde handeling, geen ingetrokken sessie.

   Eén kanaal blijft buiten deze belofte: de SSE-stroom (`/api/v1/events`).
   EventSource geeft alleen een naamloze `error` en stelt de HTTP-status niet
   beschikbaar, dus een 401 is daar niet te onderscheiden van een wegvallend
   netwerk. De eerstvolgende gewone API-aanroep merkt het wél, en die trekt de
   sessie in. */
const listeners = new Set<() => void>();
let revoked = false;

export const sessionRevoked = (): boolean => revoked;

export function onSessionRevoked(fn: () => void): () => void {
  listeners.add(fn);
  if (revoked) fn();
  return () => { listeners.delete(fn); };
}

/** Aanroepen zodra de server deze sessie afwijst. Idempotent. */
export function revokeSession(): void {
  if (revoked) return;
  revoked = true;
  for (const fn of listeners) fn();
}
